module.exports = __webpack_public_path__ + "img/yyy_shoujixiangyun.84fd28d2.png";